import { Controller } from "@hotwired/stimulus"

// Cycle through alternate Steam CDN cover assets when the preferred URL 404s.
export default class extends Controller {
  static values = { urls: Array }

  connect() {
    this.index = 0
  }

  advance() {
    this.index += 1
    const next = this.urlsValue[this.index]
    if (next) {
      this.element.src = next
      return
    }

    this.element.removeAttribute("src")
    this.element.closest(".game-list__cover-frame")?.remove()
    // Edition thumbs have no frame wrapper — just hide the broken image.
    if (!this.element.closest(".game-list__cover-frame")) {
      this.element.hidden = true
    }
  }
}
